<template>
  <div class="container py-5">
    <div class="row g-4 text-center">
      <!-- Mesa de Regalos -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100 rounded-4">
          <div class="card-body">
            <i class="bi bi-gift-fill fs-1 text-primary mb-3"></i>
            <h5 class="card-title">Mesas de Regalos</h5>
            <p class="display-6 fw-bold text-primary">{{ data.totalMesas }}</p>
            <button class="btn btn-outline-primary " @click="goTo('MisMesas')">
              Añadir nuevo
            </button>
          </div>
        </div>
      </div>

      <!-- Paquetes -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100 rounded-4">
          <div class="card-body">
            <i class="bi bi-box-seam fs-1 text-success mb-3"></i>
            <h5 class="card-title">Paquetes</h5>
            <p class="display-6 fw-bold text-success">{{ data.totalPaquetes }}</p>
            <button class="btn btn-outline-success " @click="goTo('paquetesDash')">
              Añadir nuevo
            </button>
          </div>
        </div>
      </div>

      <!-- Reservaciones -->
      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100 rounded-4">
          <div class="card-body">
            <i class="bi bi-calendar-check-fill fs-1 text-warning mb-3"></i>
            <h5 class="card-title">Reservaciones</h5>
            <p class="display-6 fw-bold text-warning">{{ data.totalReservas }}</p>
            <button class="btn btn-outline-warning " @click="goTo('Reservations')">
              Añadir nuevo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeDash",
  data() {
    return {
      data: {
        totalMesas: 0,
        totalPaquetes: 0,
        totalReservas: 0,
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        // Llama a tu endpoint Laravel (por ejemplo /api/dashboard)
        const res = await fetch("https://beauvoyage.net/api/contarElementos");
        const json = await res.json();
        this.data = json;
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    },
    goTo(page) {
      // Redirección simple (puedes cambiar a router.push si usas Vue Router)
      window.location.href = `/${page}`;
    },
  },
};
</script>

<style scoped>
.card {
  transition: transform 0.2s ease;
}
.card:hover {
  transform: translateY(-5px);
}
</style>
